import React from "react";
import './career.css';
import Helmet from 'react-helmet';
import BottomBox from './BottomBox';
import Pop from './Pop';
import AccordCareer from './AccordCareer';
import { Box } from "@mui/material";
import Readmore from "./Readmore";

const Career = (props) => {
    const {history} = props;
    const myImage={
        backgroundImage: 
        "url('/images/career.png')",
        height:'100vh',
        width:'100%',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        
    };
    return ( 
    <div className="career">
        <Helmet bodyAttributes={{style: 'background-color : white'}}/> 
        <Pop btcolor='black'/>
        <Box 
           sx = {theme => ({ [theme.breakpoints.up('sm')]:{backgroundColor:'#202020',width:'100%',height:'50vh',maxHeight:'50%'},
           [theme.breakpoints.between('0','600')]:{backgroundColor:'#202020',width:'100vw',height:'35vh',maxHeight:'50%'}
           })}
      />
    
            <p onClick={()=> history.push('/')} className='career__head'>
            Untouched
            </p>
        
            <div className='career__heading'>
            <p>Career</p> 
            </div>
        
        
         <div  className="mainhead">
            
            <p className="sechead">Wanna build something for mankind?</p>
            <div className="sechead__para">
            <div>If you want to turn uncertainties into opportunities,  problems into solutions, monotonous work into interesting work, 
            and limitations into freedom then join our team. </div>
            <p>Wanna join our team? then <b>Apply Now</b></p>
            </div>
            
            </div>
            
        {/* <Menuicon/>    */}
            
        <AccordCareer/>
        
       <BottomBox/>
       
    </div> 
    );
}
 
export default Career;